export default {
  compact: true,
  items: [
    {
      label: 'Live GeoGrids',
      href: '/geogrids',
      icon: 'fa-regular fa-border-outer',
      activeUrl: '/geogrids'
    },
    {
      label: 'Scheduled GeoGrids',
      href: '/scheduled_geogrids',
      icon: 'fa-regular fa-clock',
      activeUrl: '/scheduled_geogrids'
    },
    {
      label: 'GeoGrid Widgets',
      href: '/geogrid_widgets',
      icon: 'fa-regular fa-code',
      activeUrl: '/geogrid_widgets',
      show: (store) => {
        const { user, organization } = store
        if (!user.adminPrivileges) return false

        if (organization.isLinda) return organization.allowGgWidgetForLinda

        return organization.proPlanSubscriber
      }
    }
  ]
}
